import FlagSVG from '../../assets/svg/flag.svg';
export default FlagSVG;
